import { FormEvent, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { ENTITY_LABELS } from "../../components/change-history/changeHistoryDictionary";
import { COMMON_ENTITY_NAMES } from "../../components/change-history/changeHistoryLabels";
import HistoryTable from "../../components/change-history/HistoryTable";
import HeaderPage from "../../components/lines-managements/header/HeaderPage";
import Button from "../../components/ui/Button";
import Input from "../../components/ui/input/Input";

const ENTITY_LIST_ID = "change-history-entity-names";
const CRUMBS = ["Historiku i ndryshimeve"];

// Change history of every audited entity, newest first, with optional narrowing to one type or one
// entity and a revert per row. The filters live in the query string so entity screens can deep-link in.
const ChangeHistory: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const entityName = searchParams.get("entityName") ?? "";
  const entityId = searchParams.get("entityId") ?? "";
  const [draftName, setDraftName] = useState(entityName);
  const [draftId, setDraftId] = useState(entityId);

  // Keep the inputs in step when the filters change from outside the form (an entity cell, a deep link).
  useEffect(() => {
    setDraftName(entityName);
    setDraftId(entityId);
  }, [entityName, entityId]);

  const applyFilters = (name: string, id: string) => {
    const next: Record<string, string> = {};
    if (name) next.entityName = name;
    if (name && id) next.entityId = id;
    setSearchParams(next, { state: CRUMBS });
  };

  const onSearch = (event: FormEvent) => {
    event.preventDefault();
    applyFilters(draftName.trim(), draftId.trim());
  };

  return (
    <>
      <HeaderPage />
      <form onSubmit={onSearch} className="flex flex-wrap items-end gap-3 mb-4">
        <Input
          label="Lloji i të dhënave"
          placeholder="të gjitha"
          list={ENTITY_LIST_ID}
          value={draftName}
          onChange={(e) => setDraftName(e.target.value)}
          className="w-56"
        />
        <datalist id={ENTITY_LIST_ID}>
          {COMMON_ENTITY_NAMES.map((name) => (
            <option key={name} value={name}>
              {ENTITY_LABELS[name]}
            </option>
          ))}
        </datalist>
        <Input
          label="Numri (ID)"
          type="number"
          min={1}
          placeholder="të gjitha"
          value={draftId}
          disabled={!draftName.trim()}
          onChange={(e) => setDraftId(e.target.value)}
          className="w-40"
        />
        <Button type="submit">Filtro</Button>
        {(entityName || entityId) && (
          <Button btnType="custom" className="text-gray-600" onClick={() => applyFilters("", "")}>
            Pastro
          </Button>
        )}
      </form>
      <div className="flex flex-col" style={{ height: "calc(100vh - 15rem)" }}>
        <HistoryTable
          key={`${entityName}:${entityId}`}
          entityName={entityName}
          entityId={entityId}
          onPickEntity={(name, id) => applyFilters(name, String(id))}
        />
      </div>
    </>
  );
};

export default ChangeHistory;
